import { render, staticRenderFns } from "./LocationTracker.vue?vue&type=template&id=afd04208&scoped=true&"
import script from "./LocationTracker.vue?vue&type=script&lang=js&"
export * from "./LocationTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd04208",
  null
  
)

export default component.exports